const freeShipping = (product) => {
  let check = false

  product.metafields.map((item) => {
    if (item.key === 'free_shipping' && item.value === 'true') {
      check = true
    }
  })
  return check
}

export default freeShipping
